import React from 'react';
import Link from 'gatsby-link';
// import './style.scss';

class ContactModel extends React.Component {
  render() {
    const { ContactModelStatus, toggleContactModel, siteMeta } = this.props;
    return (

      <div className="c-contactModel" style={{ visibility: ContactModelStatus ? 'visible' : 'hidden' }} data-active={ContactModelStatus ? 'on' : 'off'} >
        <div className="c-contactModel__content">
          <div className="c-contactModel__content__col1 l-contactModel__content_col1">
            <div className="c-contactModel__content__header">
              <span className="u-epic">Gutsiest Move <br />I Ever Saw, <br />Mav.</span>
              <span className="o-tgQuote">- Hollywood</span>
            </div>
            <div className="c-contactDetails">
              <div className="c-contactDetails__detail">
                <div className="c-contatcDetails__detail__header">
                  <h6>Say Hello</h6>
                </div>
                <div className="c-contatcDetails__detail__body">
                  <span><a href={`tel:${siteMeta.contactNumber}`}>{siteMeta.contactNumber}</a></span>
                  <span><a href={`mailto:${siteMeta.contactEmail}`}>{siteMeta.contactEmail}</a></span>
                </div>
              </div>
              <div className="c-contactDetails__detail">
                <div className="c-contatcDetails__detail__header">
                  <h6>Visit Us</h6>
                </div>
                <div className="c-contatcDetails__detail__body">
                  <p><a href="https://goo.gl/maps/NtaLYxzJgAw24G8T6">GridAKL/John Lysaght - 101 Pakenham St W,<br /> Wynyard Quarter, <br />Auckland 1010</a></p>
                </div>
              </div>
            </div>
          </div>
          <div className="c-contactModel__content__form">
            <div className="c-contactModel__content__form__header">
              <h3>Great! Let's get Started...</h3>
              <p>We'll be in  touch faster than you can say <br /><span className="o-tgQuote">"Great balls of fire!" - Goose</span></p>
            </div>
            <div className="c-form c-form--large">
              <form
                name="contact"
                method="post"
                action="/thanks/"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="contact" />
                <p hidden> <label> Don’t fill this out:{' '} <input name="bot-field" /></label></p>
                <input type="text" name="name" required placeholder="Your Name" />
                <input type="email" name="email" required placeholder="Email Address" />
                <input type="telNo" name="phone" placeholder="Telephone" />
                <button type="submit">Send</button>
              </form>
            </div>
            <div className="c-contactDetails">
              <div className="c-contactDetails__detail">
                <div className="c-contatcDetails__detail__header">
                  <h6>Say Hello</h6>
                </div>
                <div className="c-contatcDetails__detail__body">
                  <span><a href={`tel:${siteMeta.contactNumber}`}>{siteMeta.contactNumber}</a></span>
                  <span><a href={`mailto:${siteMeta.contactEmail}`}>{siteMeta.contactEmail}</a></span>
                </div>
              </div>
              <div className="c-contactDetails__detail">
                <div className="c-contatcDetails__detail__header">
                  <h6>Visit Us</h6>
                </div>
                <div className="c-contatcDetails__detail__body">
                  <p><a href="https://www.google.co.nz/maps/dir/''/Goose+Level+1,+8%2F75+Ellice+Road,+Wairau+Valley+Auckland+0629/data=!4m5!4m4!1m0!1m2!1m1!1s0x6d0d392edebbd675:0xd699e15da42d675f?sa=X&ved=0ahUKEwjWrvTUlarbAhWFebwKHehJCDwQ9RcIdjAL">8/75 Ellice Road, <br />Wairau Valley, Auckland</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="c-contactModel__close">
          <div role="button" tabIndex={0} onKeyPress={toggleContactModel} onClick={toggleContactModel} className="o-cross">
            <span />
            <span />
          </div>
        </div>
      </div>
    );
  }
}

export default ContactModel;




// WEBPACK FOOTER //
// ./src/components/ContactModel/index.jsx